import { render } from "./taskReward.vue?vue&type=template&id=1eb4fa7b&scoped=true"
import script from "./taskReward.vue?vue&type=script&lang=js"
export * from "./taskReward.vue?vue&type=script&lang=js"

import "./taskReward.vue?vue&type=style&index=0&id=1eb4fa7b&scoped=true&lang=css"
import "./taskReward.vue?vue&type=style&index=1&id=1eb4fa7b&lang=css"

import exportComponent from "/home/runner/work/user-ui/user-ui/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1eb4fa7b"]])

export default __exports__